import { Injectable } from "@angular/core";

@Injectable()
export class LoggingService {

  logToConsole(message: string) {
    console.log('you have a message: ' + message);
  }

}
